import { useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  size: number;
  fill?: string;
  stroke?: string;
}

export const WorldIcon = ({ size, fill, stroke }: IProps) => {
  const theme = useTheme();
  return (
    <svg id="worldicon__assets-icons-v2__svg__l13"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill ?? 'none'}
    stroke={stroke ?? theme.palette.common.white}
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-world">
      
      <path id="worldicon__assets-icons-v2__path__l25" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="worldicon__assets-icons-v2__path__l26" d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path id="worldicon__assets-icons-v2__path__l27" d="M3.6 9h16.8" />
      <path id="worldicon__assets-icons-v2__path__l28" d="M3.6 15h16.8" />
      <path id="worldicon__assets-icons-v2__path__l29" d="M11.5 3a17 17 0 0 0 0 18" />
      <path id="worldicon__assets-icons-v2__path__l30" d="M12.5 3a17 17 0 0 1 0 18" />
    </svg>);

};